!function(factory){"use strict";"function"==typeof define&&define.amd?define(["jquery"],factory):jQuery&&!jQuery.fn.hoverIntent&&factory(jQuery)}(function($){"use strict";var cX,cY,_cfg={interval:100,sensitivity:6,timeout:0},INSTANCE_COUNT=0,track=function(ev){cX=ev.pageX,cY=ev.pageY},compare=function(ev,$el,s,cfg){if(Math.sqrt((s.pX-cX)*(s.pX-cX)+(s.pY-cY)*(s.pY-cY))<cfg.sensitivity)return $el.off(s.event,track),delete s.timeoutId,s.isActive=!0,ev.pageX=cX,ev.pageY=cY,delete s.pX,delete s.pY,cfg.over.apply($el[0],[ev]);s.pX=cX,s.pY=cY,s.timeoutId=setTimeout(function(){compare(ev,$el,s,cfg)},cfg.interval)},delay=function(ev,$el,s,out){return delete $el.data("hoverIntent")[s.id],out.apply($el[0],[ev])};$.fn.hoverIntent=function(handlerIn,handlerOut,selector){var instanceId=INSTANCE_COUNT++,cfg=$.extend({},_cfg);$.isPlainObject(handlerIn)?(cfg=$.extend(cfg,handlerIn),$.isFunction(cfg.out)||(cfg.out=cfg.over)):cfg=$.isFunction(handlerOut)?$.extend(cfg,{over:handlerIn,out:handlerOut,selector:selector}):$.extend(cfg,{over:handlerIn,out:handlerIn,selector:handlerOut});var handleHover=function(e){var ev=$.extend({},e),$el=$(this),hoverIntentData=$el.data("hoverIntent");hoverIntentData||$el.data("hoverIntent",hoverIntentData={});var state=hoverIntentData[instanceId];state||(hoverIntentData[instanceId]=state={id:instanceId}),state.timeoutId&&(state.timeoutId=clearTimeout(state.timeoutId));var mousemove=state.event="mousemove.hoverIntent.hoverIntent"+instanceId;if("mouseenter"===e.type){if(state.isActive)return;state.pX=ev.pageX,state.pY=ev.pageY,$el.off(mousemove,track).on(mousemove,track),state.timeoutId=setTimeout(function(){compare(ev,$el,state,cfg)},cfg.interval)}else{if(!state.isActive)return;$el.off(mousemove,track),state.timeoutId=setTimeout(function(){delay(ev,$el,state,cfg.out)},cfg.timeout)}};return this.on({"mouseenter.hoverIntent":handleHover,"mouseleave.hoverIntent":handleHover},cfg.selector)}});

// initializing 
(function() {
  $(document).ready(function() {
    SwellConfig.Link.initializeLinks(".swell-link-login, .swell-link-register");
    SwellConfig.LocalStorage.initializeLocalStorage();
  });

  $(document).on("swell:setup", function() {
    Swell.Campaign.initializeCampaigns(".swell-campaign-list", SwellConfig.Campaign.opts);
    SwellConfig.Campaign.authenticate();
    SwellConfig.Tier.initializeDummyTier();
    SwellConfig.Tier.initializeCustomTierProperties();
    SwellConfig.Tier.initializeTiers(".swell-tier-table");
    SwellConfig.Referral.initializeReferral(".swell-referral");
    SwellConfig.Customer.initializeHistory(".swell-history-link");

    $(".swell-referral-loader").remove();
    
    if(window.location.href.indexOf("thank_you") > 0 || window.location.href.indexOf("order") > 0) {
      $(".swell-post-checkout-wondercide").css("display", "flex");
      $( 'body' ).on('click',".swell-post-checkout-wondercide .checkout-heading .swell-referral-back-link", function() {
        $(".swell-post-checkout-wondercide").hide();
      });
    }

    if(spapi.authenticated) {
      $(".swell-campaign").addClass("logged-in");
    }

    redemptionoptions = spapi.activeRedemptionOptions;
    redemptionoptions.forEach(function(option) {
      id = option.id;
      cost = option.cost_text;
      name = option.name;
      if(option.discount_type == "cart_fixed_amount") {
        $(".swell-redemption-option-list").append('<li class="redeem-off swell-redemption-link" data-redemption-option-id="' + id +'"> <div class="redeem-off-holder"> <div class="redeem-content-holder"> <div class="redeem-content-header">' + name + '</div> <div class="redeem-content-text">' + cost + ' </div> </div> </div> </li>')
      } else {
        $(".swell-recharge-redemption-option-list").append('<li class="redeem-off swell-recharge-redemption" data-redemption-option-id="' + id +'"> <div class="redeem-off-holder"> <div class="redeem-content-holder"> <div class="redeem-content-header">' + name + '</div> <div class="redeem-content-text">' + cost + ' </div> </div> </div> </li>')
      }
    });

    swellAPI.refreshEmbeds();
    
    $("body").on("click", ".swell-refer-campaign", function(e){
      window.location = "/pages/refer"
    });
    

    if(spapi.authenticated) {
      $(".swell-recharge-redemption-option-list .swell-recharge-redemption").css("cursor", "pointer")
      
      $("body").on("click", ".swell-recharge-redemption", function(e){
        e.preventDefault();

        redemptionOptionId = $(this).data("redemption-option-id");
        redemptionOption = spapi.findActiveRedemptionOptionById(redemptionOptionId);

        $("#redemption-model #swell-reward-heading").html(redemptionOption.name);
        $("#redemption-model #swell-coupon-intro").html(redemptionOption.description);
        $("#redemption-model #swell-coupon-code").html('');
        $("#redemption-model .swell-redeem-btn").show();
        $("#redemption-model .swell-redeem-btn").html('Redeem');
        $("#redemption-model .swell-redeem-btn").data('redemption-option-id', redemptionOptionId);

        $("#redemption-model").css("display", "flex");
      });

      $("body").on("click", "#redemption-model .swell-redeem-btn", function(e) {
        $("#redemption-model .swell-redeem-btn").html('please wait...');
        redemptionOptionId = $(this).data("redemption-option-id");
        redemptionOption = spapi.findActiveRedemptionOptionById(redemptionOptionId);

        var onExecution = function(redemption) {
          $("#redemption-model #swell-reward-heading").html(redemption.redemptionOption.name);
          $("#redemption-model #swell-coupon-intro").html(redemption.redemptionOption.description);
          $("#redemption-model #swell-reward-intro").html(redemption.redemptionOption.reward_intro);
          $("#redemption-model #swell-coupon-code").html(redemption.couponCode);
          $("#redemption-model .swell-redeem-btn").hide();
        };

        var onError = function(err) {
          $("#redemption-model #swell-reward-heading").html(redemptionOption.name);
          $("#redemption-model #swell-coupon-intro").html("Oops, we couldn't apply this discount to your next charge. This may be because you don't have enough points or already have a discount applied to your next charge");
          $("#redemption-model .swell-redeem-btn").hide();
        };

        if(spapi.customer.adjusted_points_balance > redemptionOption.amount) {
          result = swellAPI.makeRedemption({redemptionOptionId: redemptionOptionId}, onExecution, onError );
        } else {
          $("#redemption-model #swell-reward-heading").html(redemptionOption.name);
          $("#redemption-model #swell-coupon-intro").html("Sorry, you do not have enough points to redeem this coupon.");
          $("#redemption-model .swell-redeem-btn").hide();
        }

      });

      $("body").on("click", "#redemption-model .close", function(e) {
        $("#redemption-model").hide();
      });
    }


    setupReferrals();

    redemptionoptions = spapi.activeRedemptionOptions;
    redemptionoptions.forEach(function(option) {
      id = option.id;
      cost = option.cost_text;
      name = option.name;
      if(option.discount_type == "cart_fixed_amount") {
        $(".swell-rewards-points").append('<option value="' + id +'"> ' + name +' </option>')
      }
    });

    // cart redemption functionality
    $("#swell-redeem-btn").click(function(){
      $("#swell-redeem-btn").html("<i class='fa fa-spin fa-spinner'></i>");
      redemptionOptionId = $("#redemption-options").val();
      redemptionOption = swellAPI.findActiveRedemptionOptionById(redemptionOptionId);
      if(redemptionOption.amount <= spapi.customer.adjusted_points_balance){
        result = swellAPI.buyMultipleWithPoints([redemptionOption], function(){});
      }
      else
      {
        onError();
      }
    });

    function onError() {
      $(".swell-error").show();
      $("#swell-redeem-btn").html("Apply Redemption");
    }

    $(document).on("swell:cart:updated", function(){
      window.location = "/cart"
    });

    Swell.Cart.items.forEach(function(item) {
      if (item.properties._swell_discount_amount_cents) {
        redeemedRedemptionOption = swellAPI.findActiveRedemptionOptionById(item.properties._swell_redemption_option_id);
        $(".cart table tbody").append('<tr class="swell-coupon-row"> <td class="swell-coupon-image image"> <div class="swell-coupon-image-holder">' + redeemedRedemptionOption.name + '</div> </td> <td class="swell-coupon-name title"> ' + redeemedRedemptionOption.name + ' <br> <p class="hidden-sm-down"> <a href="javascript:void(0);" class="btn btn--small btn--secondary cart__remove swell-coupon-remove">Remove</a> </p> </td> <td class="swell-coupon-quantity quantity"> 1 </td> <td class="swell-coupon-amount price"> - ' + redeemedRedemptionOption.amount + ' points </td> <td class="swell-coupon-amount total"> - ' + redeemedRedemptionOption.amount + ' points </td>   <td class="swell-coupon-remove remove"> <a title="Remove" href="javascript:void(0)" class="swell-cross" tabindex="0"> </a></td> </tr>');
        return
      }
    });

    $('body').on('click',".swell-coupon-remove", function() {
      $(".swell-coupon-remove").html("<i class='fa fa-spin fa-spinner'></i>");
      swellAPI.removeRedemptionOptionIdFromCart(redeemedRedemptionOption.id, function(){});
    });
    // cart redemption functionality ends

    $( document ).on('click',"#swell-referral-register-submit", function() {
      setTimeout(function(){
        if(spapi.customer.referral_receipts) {
          setupReferrals();
          if(spapi.customer.email) {
            $(".swell-referral-content-main").addClass("refer-step");
          }
        } else {
          setTimeout(function(){
            setupReferrals();
            if(spapi.customer.email) {
              $(".swell-referral-content-main").addClass("refer-step");
            }
          },1000)
        }
      },1000)
    });

    $(document).on("swell:referral:success", function() {
      swellAPI.refreshCustomerDetails(function(){
        var customerDetails = swellAPI.getCustomerDetails();
        referrals = customerDetails.referrals;

        $(".redeem-holder").show();

        $(".swell-referral-table tbody").html("");

        referrals.forEach(function(referral) {
          status = null;

          if(referral.completedAt){ 
            status = "Purchased(" + spapi.activeReferralCampaign.reward_text + " earned)";
          } else {
            status = "Invited";
          }

          $(".swell-referral-table tbody").append('<tr> <td>' +  referral.email + '</td><td>' + status +'</td></tr>');
        });
      });
    });

    $(document).on("swell:referral:error", function(jqXHR, textStatus, errorThrown) { 
      if(textStatus && textStatus === "EMAILS_ALREADY_PURCHASED"){
        $(".refer-customer-error").remove();
        $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Sorry! Looks like this person has already made a purchase. Try referring another friend.</p>');
        $("#swell-referral-refer-emails").addClass("error-border");
      }

      if(textStatus && textStatus === "Please enter a valid email address"){
          $(".refer-customer-error").remove();
          $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Please enter valid email addresses seperated with commas</p>');
          $("#swell-referral-refer-emails").addClass("error-border");
        }
    });

    $(".mobile-arrows .left-arrow").click(function() {
      var last = false;
      var length = $(".swell-tier-table thead tr:nth-child(1) th").length;

      for(counter = 2; counter <= length ; counter++) { 
       if (!$(".swell-tier-table thead tr th:nth-child(" + counter + ")").hasClass("hidden")) {
         if(counter == length) {
           last = true;
         }
         break;
       }
      }

      if(last == true) {
       $(".swell-tier-table  tr th:nth-child(" + counter + ")").addClass("hidden");
       $(".swell-tier-table  tr th:nth-child("+(counter - 2)+")").removeClass("hidden");

       $(".swell-tier-table  tr td:nth-child(" + counter + ")").addClass("hidden");
       $(".swell-tier-table  tr td:nth-child("+(counter - 2)+")").removeClass("hidden");
      } else {
       $(".swell-tier-table  tr th:nth-child(" + counter + ")").addClass("hidden");
       $(".swell-tier-table  tr th:nth-child("+(counter + 1)+")").removeClass("hidden");

       $(".swell-tier-table  tr td:nth-child(" + counter + ")").addClass("hidden");
       $(".swell-tier-table  tr td:nth-child("+(counter + 1)+")").removeClass("hidden");
      }        
    });

    $(".mobile-arrows .right-arrow").click(function() {
      var first = false;
      var length = $(".swell-tier-table thead tr:nth-child(1) th").length;

      for(counter = 2; counter <= length ; counter++) { 
       if (!$(".swell-tier-table thead tr th:nth-child(" + counter + ")").hasClass("hidden")) {
         if(counter == 2) {
           first = true;
         }
         break;
       }
      }

      if(first == true) {
       $(".swell-tier-table  tr th:nth-child(" + counter + ")").addClass("hidden");
       $(".swell-tier-table  tr th:nth-child("+(counter + 2)+")").removeClass("hidden");

       $(".swell-tier-table  tr td:nth-child(" + counter + ")").addClass("hidden");
       $(".swell-tier-table  tr td:nth-child("+(counter + 2)+")").removeClass("hidden");
      } else {
       $(".swell-tier-table thead tr th:nth-child(" + counter + ")").addClass("hidden");
       $(".swell-tier-table thead tr th:nth-child("+(counter - 1)+")").removeClass("hidden");

       $(".swell-tier-table tbody tr td:nth-child(" + counter + ")").addClass("hidden");
       $(".swell-tier-table tbody tr td:nth-child("+(counter - 1)+")").removeClass("hidden");
      }        
    });

  });
}).call(this);

function setupReferrals (){
  if(spapi.authenticated || spapi.customer.email) {
    if(spapi.customer.referral_receipts.length > 0) {
      $(".redeem-holder").show();

      referrals = spapi.customer.referral_receipts;

      referrals.forEach(function(referral) {
        status = null;

        if(referral.completed_at){ 
          status = "Purchased(" + spapi.activeReferralCampaign.reward_text + " earned)";
        } else {
          status = "Invited";
        }

        $(".swell-referral-table tbody").append('<tr> <td>' +  referral.email + '</td><td>' + status +'</td></tr>');
      });  
    }
  }
}

// campaigns
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Campaign = {
    opts: {
      templates: {
        campaign: "<li class='swell-campaign'> <div class='swell-campaign-content swell-campaign-link' data-display-mode='modal' data-campaign-id='<%= campaign.id %>'> <div class='swell-campaign-icon'> <span class='swell-campaign-icon-content'> <i class='<%= campaign.icon %>'></i> </span> </div> <div class='campaign-content-holder'> <div class='swell-campaign-value'> <span class='swell-campaign-value-content'><%= campaign.reward_text %></span> </div> <div class='swell-campaign-type'> <span class='swell-campaign-type-content'><%= campaign.title %></span> </div> </div> </div> </li>"
        // campaignHover: "<div class=\"swell-campaign-hover\">\n  <div class=\"swell-campaign-hover-content\">\n    <ul class=\"swell-link-list\">\n      <li class=\"swell-link\">\n        <a href=\"/account/login\" class=\"swell-link-login\">Sign In</a>\n      </li>\n      <li class=\"swell-link\">\n        <a href=\"/account/register\" class=\"swell-link-register\">Sign Up</a>\n      </li>\n    </ul>\n  </div>\n</div>"
      }
    },
    authenticate: function() {
      if (!spapi.authenticated) {
        spapi.$(document).off("click", ".swell-campaign-content");
        $(".swell-campaign").addClass("swell-campaign-login");
        return $(".swell-campaign-content").hover(function() {
          return $(this).append(SwellConfig.Campaign.opts.templates.campaignHover);
        }, function() {
          return $(this).find(".swell-campaign-hover").remove();
        });
      }
    }
  };
}).call(this);

// history popup
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Customer = {
    initializeHistory: function(containerSelector) {
      return $(containerSelector).click(function() {
        return swellAPI.showPopupByType("HistoryPopup");
      });
    }
  };
}).call(this);


// links
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Link = {
    initializeLinks: function(containerSelector) {
      return $(document).on("click", containerSelector, function(e) {
        var href;
        e.preventDefault();
        href = $(this).attr("href");
        localStorage.setItem("swell-location", "/pages/rewards");
        return window.location = href;
      });
    }
  };
}).call(this);

// local storage
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.LocalStorage = {
    initializeLocalStorage: function() {
      var location;
      location = localStorage.getItem("swell-location");
      if (location && window.location.pathname === '/account') {
        localStorage.removeItem("swell-location");
        return window.location = location;
      }
    }
  };
}).call(this);

// redemption
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Redemption = {
    opts: {
      templates: {
        redemptionOption: '<li class="redeem-off"> <div class="redeem-off-holder"> <div class="redeem-content-holder"> <div class="redeem-content-header"><%= redemption.name %> </div> <div class="redeem-content-text"><%= redemption.cost_text %> </div> </div> </div> </li>'
      }
    }
  };
}).call(this);

// referral
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Referral = {
    opts: {
      localization: {
        referralSidebarDetailsAction: "Refer a Friend",
        referralSidebarDetailsReward: "<%= referralCampaign.reward_text %>",

        referralRegisterHeading: " Give <%= referralCampaign.reward_text %>, Get <%= referralCampaign.reward_text %>",
        referralRegisterFormDetails: "Enter your email below to get started",
        referralRegisterFormEmail: "Enter email",
        referralRegisterFormSubmit: "Next",
        referralRegisterDetails: "<%= referralCampaign.details %>",

        referralReferHeading: " Give <%= referralCampaign.reward_text %>, Get <%= referralCampaign.reward_text %>",
        referralReferFormEmails: "your friends' emails (separated by Commas)",
        referralReferFormSubmit: "Send",
        referralReferFormDetails: "Now, enter your friends' emails below.",
        referralReferFormEmailsDetails: "",
        referralReferDetails: "<%= referralCampaign.details %>",

        referralReferMediaDetails: "You can also share your link with the buttons below",

        referralShareFacebook: "Share",
        referralShareTwitter: "Tweet",
        referralShareCopy: "Copy Link",
        referralShareMessenger: "Message",
        referralShareSMS: "SMS",

        referralFacebookIcon: "swell-icon-facebook-share-mob",
        referralTwitterIcon: "swell-icon-tweet-mob",
        referralLinkIcon: "swell-icon-copy-link-mob",
        referralMessengerIcon: "swell-icon-fb-message-mob",
        referralSMSIcon: "swell-icon-sms-mob",

        referralThanksHeading: "Thanks for Referring!",
        referralThanksDetails: "Remind your friends to check their emails.",

        referralCopyHeading: "",
        referralCopyButton: "Copy Link",
        referralCopyDetails: "Copy link and share with your friends."
      },
      templates: {
        referralRefer: '<div class="swell-referral-refer"> <h2 class="swell-referral-heading"><%= localization.referralReferHeading %></h2> <p class="swell-referral-details"><%= localization.referralReferDetails %></p> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralReferFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" required="required" placeholder="<%= localization.referralReferFormEmails %>"> <span class="swell-referral-form-field-details"><%= localization.referralReferFormEmailsDetails %></span> </li> </ul> </div> <div class="swell-referral-form-footer"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit" value="<%= localization.referralReferFormSubmit %>"> </div> </form> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details"><%= localization.referralReferMediaDetails %></p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralFacebookIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareFacebook %> </div> </li> <li class="swell-referral-medium swell-share-referral-twitter"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralTwitterIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareTwitter %> </div> </li> <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralMessengerIcon %>" aria-hidden="true"> <span class="path1"></span> <span class="path2"></span> </i> &nbsp; <span><%= localization.referralShareMessenger %> </span> </div> </li> <li class="swell-referral-medium swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralSMSIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareSMS%> </div> </li> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralLinkIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareCopy %> </div> </li> </ul> </div> </div>'
      }
    },
    initializeReferral: function(containerSelector) {
      var email = $(containerSelector).data("customer-email");
      if (email) {
        spapi.storage.setItem("referrer_email", email);
        spapi.customer.email = email;
      }
      Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
    }
  };
}).call(this);

// tiers
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Tier = {
    getCustomerTierId: function() {
      var customer_tier, intro_tier, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier) {
        return customer_tier.id;
      } else {
        intro_tier = $.grep(tiers, function(e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].id;
        } else {
          return null;
        }
      }
    },
    getCustomerTierRank: function() {
      var customer_tier, intro_tier, rank, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier && customer_tier.id) {
        rank = $.grep(tiers, function(e) {
          return e.id === customer_tier.id;
        })[0].rank;
        return rank;
      } else {
        intro_tier = $.grep(tiers, function(e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].rank;
        } else {
          return null;
        }
      }
    },
    getTierByRank: function(rank) {
      var tiers;
      tiers = spapi.activeVipTiers;
      return $.grep(tiers, function(e) {
        return e.rank === rank;
      })[0];
    },
    setupCustomerTierStatus: function() {
      var $tierStatusRow, $tierValueRow, col, columnLength, customer_tier_id, customer_tier_rank, data_id, dollar_difference, encouragement, index, k, l, next_tier, ref, ref1;
      customer_tier_id = SwellConfig.Tier.getCustomerTierId();
      customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
      next_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank + 1);
      $(".swell-tier-table").addClass("swell-tier-status");
      $(".swell-tier-table thead").prepend("<tr class=\"swell-tier-status-row\">\n  <th scope=\"row\"></th>\n</tr>");
      
      tiers = spapi.activeVipTiers;
      tiers.forEach(function(tier) {
        if(tier.id  == customer_tier_id) {
          customer_tier = tier;
        }
      });
            
      tiers.forEach(function(tier) {
        if(tier.rank < customer_tier.rank) {
          $(".swell-tier-table thead .swell-tier-status-row").append('<th scope="col"> </th>');
        } else if(tier.rank == customer_tier.rank) {
          $(".swell-tier-table thead .swell-tier-status-row").append('<th scope="col"> <span class="current-status">Current status <span class="arrow-down"></span></span> </th>');
        } else if (next_tier && tier.rank == next_tier.rank) {
          if(spapi.customer.vip_tier_stats) {
            tier_difference = (tier.amount_spent_cents - spapi.customer.vip_tier_stats.amount_spent_cents)/100;
          } else {
            tier_difference = (tier.amount_spent_cents - 0)/100;
          }
          $(".swell-tier-table thead .swell-tier-status-row").append('<th scope="col"><span class="next-status">Spend $' + tier_difference + ' more for ' + tier.name + '</span></th>');
        } else {
          $(".swell-tier-table thead .swell-tier-status-row").append('<th scope="col"> </th>');
        }
      });
      if (spapi.isMobile) {
        SwellConfig.Tier.tierTableOnMobile(customer_tier_rank + 2);
      }
    },
    tierTableOnMobile: function(current) {
       var columnLength = $(".swell-tier-table .swell-tier-values").children().length;
       for(counter = 2;counter<=columnLength;counter++) {
         if(counter!=current) {
           $(".swell-tier-table tr th:nth-child(" + counter + ")").addClass("hidden");
           $(".swell-tier-table tr td:nth-child(" + counter + ")").addClass("hidden");
         }      
       }
     },
    initializeDummyTier: function() {
      var k, len, tier, tiers;
      tiers = spapi.activeVipTiers;
      for (k = 0, len = tiers.length; k < len; k++) {
        tier = tiers[k];
        tier.rank += 1;
      }
      return tiers.unshift({
        id: -1,
        rank: 0,
        name: "Silver",
        points: "Qualifying Amount: $0&ndash;$149",
        one_point_multiplier: '1X',
        // early_sales: '<span class="circle"></span>',
        free_shipping: "",
        swellrequiredAmountSpent: "$0",
        swellrequiredAmountSpentCents: 0,
        swellrequiredPointsEarned: 0,
        swellrequiredPurchasesMade: 0,
        swellrequiredReferralsCompleted: 0
      });
    },
    initializeCustomTierProperties: function() {
      spapi.activeVipTiers[1].name = "Gold";
      spapi.activeVipTiers[1].points = "Qualifying Amount: $150&ndash;$249";
      spapi.activeVipTiers[1].one_point_multiplier = '1.25X';
      // spapi.activeVipTiers[1].early_sales = '<span class="circle"></span>';
      spapi.activeVipTiers[1].free_shipping = '<span class="circle"></span>';
      spapi.activeVipTiers[2].name = "Platinum";
      spapi.activeVipTiers[2].points = "Qualifying Amount: $250+";
      spapi.activeVipTiers[2].one_point_multiplier = "1.5X";
      spapi.activeVipTiers[2].early_sales = '<span class="circle"></span>';
      spapi.activeVipTiers[2].free_shipping = '<span class="circle"></span>';
    },
    initializeTiers: function(containerSelector) {
      var i, j, key, properties, property, ref, ref1, tiers;
      if ($(containerSelector).length === 0) {
        return "";
      }
      tiers = spapi.activeVipTiers;
      properties = {
        header: {
          name: {
            className: "swell-tier-names",
            title: ""
          },
          points: {
            className: "swell-tier-values",
            title: "Benefits"
          }
        },
        body: {
          one_point_multiplier: {
            title: "Point Multiplier"
          },
          // early_sales: {
          //   title: "Early Access to Sales"
          // },
          free_shipping: {
            title: "Free Shipping"
          }
        }
      };
      $(containerSelector).append("<thead></thead>");
      $(containerSelector).append("<tbody></tbody>");
      j = 0;
      ref = properties.header;
      for (key in ref) {
        property = ref[key];
        $(containerSelector).find("thead").append("<tr class=\"" + property.className + "\">\n  <th scope=\"row\">" + property.title + "</th>\n</tr>");
        tiers.forEach(function(tier) {
          return $(containerSelector).find("thead tr:eq(" + j + ")").append("<th scope=\"col\" data-tier-id=\"" + tier.id + "\">" + tier[key] + "</th>");
        });
        j++;
      }
      i = 0;
      ref1 = properties.body;
      for (key in ref1) {
        property = ref1[key];
        $(containerSelector).find("tbody").append("<tr>\n  <th scope=\"row\">" + property.title + "</th>\n</tr>");
        tiers.forEach(function(tier) {
          return $(containerSelector).find("tbody tr:eq(" + i + ")").append("<td data-tier-id=\"" + tier.id + "\">" + tier[key] + "</td>");
        });
        i++;
      }
      if (spapi.authenticated) {
        return SwellConfig.Tier.setupCustomerTierStatus();
      } else if (spapi.isMobile){
        SwellConfig.Tier.tierTableOnMobile(2);
      }

      $(window).resize(function(){
        if($(document).width() < 758) {
          if(spapi.authenticated) {
            SwellConfig.Tier.tierTableOnMobile(customer_tier_rank + 2);
          } else {
            SwellConfig.Tier.tierTableOnMobile(2);
          }
          
        } else {
         $(".swell-tier-table  tr th").removeClass("hidden");
         $(".swell-tier-table  tr td").removeClass("hidden");
        }
      });
    }
  };
}).call(this);
